import React from "react";
import { Avatar, Box, Typography, useTheme } from "@mui/material";
import PropTypes from "prop-types";

interface Props {
  name: string;
}

const AVATAR_COLORS = [
  "#2563EB",
  "#7C3AED",
  "#059669",
  "#D97706",
  "#0891B2",
  "#DC2626",
  "#4F46E5",
];

const stringToColor = (string: string) => {
  let hash = 0;
  for (let i = 0; i < string.length; i += 1) {
    hash = string.charCodeAt(i) + ((hash << 5) - hash);
  }
  const index = Math.abs(hash) % AVATAR_COLORS.length;
  return AVATAR_COLORS[index];
};

const getInitials = (str: string) => {
  const parts = str.trim().split(/\s+/);
  if (parts.length >= 2) {
    return (parts[0][0] + parts[1][0]).toUpperCase();
  }
  return (parts[0]?.[0] || "?").toUpperCase();
};

export const LastUpdatedByAvatar: React.FC<Props> = ({ name }) => {
  const theme = useTheme();

  if (!name || name === "Not available" || name === "Not updated yet") {
    return (
      <Typography
        variant="body2"
        sx={{
          color: "text.disabled",
          fontSize: "0.85rem",
          fontWeight: 500,
          userSelect: "none",
        }}
      >
        —
      </Typography>
    );
  }

  const color = stringToColor(name);
  const initials = getInitials(name);

  return (
    <Box
      sx={{
        display: "inline-flex",
        alignItems: "center",
        gap: 1,
      }}
    >
      <Avatar
        sx={{
          width: 26,
          height: 26,
          fontSize: "0.72rem",
          fontWeight: 700,
          backgroundColor: color,
          color: "#ffffff",
          boxShadow: `0 0 0 1px ${theme.palette.background.paper}`,
        }}
      >
        {initials}
      </Avatar>
      <Typography
        variant="body2"
        sx={{
          fontSize: "0.82rem",
          fontWeight: 500,
          color: "text.primary",
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
          maxWidth: 130,
        }}
      >
        {name}
      </Typography>
    </Box>
  );
};

LastUpdatedByAvatar.propTypes = {
  name: PropTypes.string.isRequired,
};

